import React, { useState } from 'react';
import { DatePickerModal } from 'AppSrc/core/components/forms/form-base-components/sub-components/date-picker-modal';
import { CalenderSvg } from 'AppSrc/core/components/common/svg-icons';
import { getDateDisplay } from 'AppSrc/core/crq/crq-table-utils';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/v-f-date-picker.css';

const CrqListRaisedDateFilter = ({
  selectedRaisedDate,
  setSelectedRaisedDate,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const displayValue = selectedRaisedDate ? getDateDisplay(selectedRaisedDate) : 'DD/MM/YYYY';
  return (
    <div className="crq-list-date-filter v-f-field-type">
      <h3>Raised date</h3>
      <div className="v-f-date-picker">
        <button
          type="button"
          onClick={() => setModalOpen(true)}
          className="selected-date selected-date-modal-button"
        >
          <div className="selected-date-inner-filter">
            <p className="selected-date-text">
              {displayValue}
            </p>
            <div className="calender-svg-wrapper">
              <CalenderSvg />
            </div>
          </div>
        </button>
      </div>
      {modalOpen && (
        <DatePickerModal
          savedSelectedRaisedDate={selectedRaisedDate}
          toggleModal={() => setModalOpen(!modalOpen)}
          updateValue={(value) => {
            setSelectedRaisedDate(value.selectedRaisedDate);
            setModalOpen(false);
          }}
          showKey={false}
        />
      )}
    </div>
  );
};

CrqListRaisedDateFilter.propTypes = {
  selectedRaisedDate: PropTypes.instanceOf(Date),
  setSelectedRaisedDate: PropTypes.func,
};

export { CrqListRaisedDateFilter };
